import React from 'react';
import { useSelector } from 'react-redux';

import { Checkbox, Input, Select, Space } from 'antd';
import FileUpload from '../../../../../../../components/FileUpload';
import AttachmentImageViewModal from '../../../../../../../components/Modal/AttachmentImageViewModal';

export const TableCol = (action, status) => {
  const _static = useSelector((state) => state.static);
  const { staticData } = _static;
  const {
    research_grant_type: researchGrantType,
    research_academic_grant_status: researchGrantStatus
  } = staticData;

  return [
    {
      key: 'application_type',
      dataIndex: 'application_type',
      title: 'Grant Application Type',
      render: (value, row) => {
        const _researchGrantType = researchGrantType.filter(
          (item) => item.value === Number(value)
        );
        const _researchGrant = _researchGrantType[0];

        return (
          <Select
            style={{ width: '250px' }}
            options={[
              ...researchGrantType.map((item) => ({
                value: item.value,
                label: <div>{item.label}</div>
              }))
            ]}
            defaultValue={_researchGrant.value}
            placeholder="Select a Event"
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => action({ ...row, application_type: e })}
          />
        );
      }
    },
    {
      key: 'detail',
      dataIndex: 'detail',
      title: 'Details',
      render: (value, row) => (
        <Input
          placeholder="Enter"
          value={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) => action({ ...row, detail: e.target.value })}
        />
      )
    },
    {
      key: 'is_lead_applicant',
      dataIndex: 'is_lead_applicant',
      title: 'Lead Applicant',
      render: (value, row) => (
        <Checkbox
          placeholder="Enter"
          defaultChecked={value}
          disabled={status === 1 || status === 2 || status === 3}
          onChange={(e) =>
            action({ ...row, is_lead_applicant: e.target.checked })
          }
        />
      )
    },
    {
      key: 'status',
      dataIndex: 'status',
      title: 'Status',
      render: (value, row) => {
        const _researchGrantStatus =
          researchGrantStatus?.length > 0
            ? researchGrantStatus.filter((item) => item.value === Number(value))
            : [];
        const _grantStatus = _researchGrantStatus[0];

        return (
          <Select
            style={{ width: '250px' }}
            options={[
              ...researchGrantStatus.map((item) => ({
                value: item.value,
                label: <div>{item?.label}</div>
              }))
            ]}
            defaultValue={_grantStatus?.value}
            placeholder="Select a Event"
            disabled={status === 1 || status === 2 || status === 3}
            onChange={(e) => action({ ...row, status: e })}
          />
        );
      }
    },
    {
      key: 'upload',
      dataIndex: 'attachment',
      title: 'Attachments(Need head approval document)',
      render: (fileList, row) => (
        <Space>
          <FileUpload fileList={fileList} row={row} action={action} disabled={status === 1 || status === 2 || status === 3} status={status} />
          
          <AttachmentImageViewModal
            row={row}
            parentKey="attachment"
            title="Course Attachments"
          // status={status}
          />
        </Space>
      )
    },
    {
      key: 'apa_point',
      dataIndex: 'apa_point',
      title: 'APA Point'
    }
  ];
};
